<template>
  <sidenav
    :custom_class="color"
    :class="[isRTL ? 'fixed-end' : 'fixed-start']"
    v-if="showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 overflow-x-hidden"
    style="margin-left: 280px; transition: margin-left 0.3s ease"
  >
    <!-- nav -->
    <navbar
      :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="navbarMinimize"
      v-if="showNavbar"
    />
    <router-view />
  </main>
</template>
<script>
import Sidenav from "./common/Sidenav";
import Navbar from "@/common/Navbars/Navbar.vue";
import { mapMutations, mapState } from "vuex";
import EventBus from "vue3-eventbus";
import $ from "jquery";

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
  },
  mounted() {
    this.checkWindowSize();
    window.addEventListener("resize", this.checkWindowSize);

    window.addEventListener("storage", (event) => {
      if (event.key === "logout-event") {
        // Reload the current tab
        window.location.reload();
      }
    });

    EventBus.on("ToggleCollapseEvent", (deplay) => {
      setTimeout(() => {
        this.updateMainContentMargin();
      }, deplay);
    });

    this.$nextTick(() => {
      this.updateMainContentMargin();
    });
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize", "toggleCollapse"]),
    checkWindowSize() {
      if (window.innerWidth < 1200) {
        this.toggleCollapse();
      }

      this.updateMainContentMargin();
    },
    updateMainContentMargin() {
      if (!this.showSidenav) {
        $(".main-content").css("margin-left", 0);
        console.log("showSidenav is false, setting margin-left to 0");
        return;
      }

      let attempts = 0;
      const maxAttempts = 40;

      const checkSidenav = () => {
        if ($("#sidenav-main").length) {
          const sidenavWidth = $("#sidenav-main").width();

          $(".sidenav.fixed-start+.main-content").css(
            "margin-left",
            sidenavWidth + 20
          );
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkSidenav, 50);
        } else {
          $(".main-content").css("margin-left", 0);
        }
      };

      checkSidenav();
    },

    forceUpdateMargin() {
      this.updateMainContentMargin();
    },
  },
  provide() {
    return {
      updateMainContentMargin: this.updateMainContentMargin,
      forceUpdateMargin: this.forceUpdateMargin,
    };
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkWindowSize);
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
      "isCollapsed",
    ]),
  },
  watch: {
    showSidenav() {
      this.$nextTick(() => {
        this.updateMainContentMargin();
      });
    },
    isCollapsed() {
      this.$nextTick(() => {
        this.updateMainContentMargin();
      });
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  },
};
</script>
